import { useEffect, useMemo } from 'react';

import FadeDiv from '@/components/Common/FadeDiv';
import FeedbackBlockTooltip from '@/features/Feedback/components/FeedbackBlockTooltip/FeedbackBlockTooltip';
import useFeedbackBlockTooltip from '@/features/Feedback/components/FeedbackBlockTooltip/useFeedbackBlockTooltip';
import { ContentStyle } from '@/styles/ContentStyle';

import feedbackDetailUtils from '../../utils/feedbackDetailutils';

type Props = {
  detail: FeedbackT;
  focusedBlock?: string;
};

export const RawTextDisplay = (props: Props) => {
  const { tooltipInfo, currentBlockInfo, onMouseMove, onMouseLeave } =
    useFeedbackBlockTooltip({
      blocks: props.detail.blocks || [],
    });

  const textHTML = useMemo(() => {
    return feedbackDetailUtils
      .setBlockTags({
        text: props.detail.raw_text || '',
        blocks: props.detail.blocks || [],
        focusedBlock: props.focusedBlock,
      })
      .replaceAll('\n', '<br/>');
  }, [props.detail.blocks, props.detail.raw_text, props.focusedBlock]);

  useEffect(() => {
    setTimeout(() => {
      const target = document.querySelector(
        `[data-block-id="${props.focusedBlock}"]`,
      );
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      }
    }, 100);
  }, [props.focusedBlock]);

  return (
    <FadeDiv status={true} duration={300}>
      <ContentStyle
        dangerouslySetInnerHTML={{ __html: textHTML }}
        onMouseLeave={onMouseLeave}
        onMouseMove={onMouseMove}
      />
      <FeedbackBlockTooltip
        tooltipInfo={tooltipInfo}
        currentBlockInfo={currentBlockInfo}
      />
    </FadeDiv>
  );
};
